import { Box, Button } from "@mui/material";
import { TWTabGroup } from "apps/web/src/componentLibrary/TWTabGroup/TWTabGroup";
import { useOffsetPagination } from "apps/web/src/utils/pagination";
import { AthleteGoalTable } from "apps/web/src/views/Athlete/GoalTracker/AthleteGoalTable";
import { GoalConfigurationCreateDialog } from "apps/web/src/views/Athlete/GoalTracker/GoalConfiguration/GoalConfigurationCreateModal";
import { CreateGoalConfigurationInputType } from "apps/web/src/views/Athlete/GoalTracker/GoalConfiguration/GoalConfigurationSchema";
import React, { useState } from "react";
import { useParams } from "react-router-dom-v5-compat";
import { RefetchQueriesContextProvider } from "../../../../contexts/RefetchQueries";
import {
  GoalConfigurationsForAthleteTableDocument,
  useCreateGoalConfigurationWithDaysOfWeekMutation,
  useCreateGoalConfigurationWithIndividualDatesMutation,
  useGoalConfigurationsForAthleteTableQuery,
} from "../../../../types";

const CURRENT_GOALS = "Current Goals";
const PAST_GOALS = "Past Goals";
export type GoalMode = typeof CURRENT_GOALS | typeof PAST_GOALS;

export const AthleteGoalsPage = () => {
  const { athleteId: maybeAthleteId } = useParams();
  const athleteId = maybeAthleteId || "";
  const [goalMode, setGoalMode] = useState(CURRENT_GOALS);
  const [createDialogOpen, setCreateDialogOpen] = useState<boolean>(false);

  const paginationHooks = useOffsetPagination();
  const { limit, offset } = paginationHooks;

  const getAthleteGoalsVars = { athleteId, input: { limit, offset }, current: goalMode === CURRENT_GOALS };
  const { data, loading } = useGoalConfigurationsForAthleteTableQuery({
    variables: getAthleteGoalsVars,
  });
  const refetchQueries = [{ query: GoalConfigurationsForAthleteTableDocument, variables: getAthleteGoalsVars }];
  const [createGoalConfigurationWithDaysOfWeek] = useCreateGoalConfigurationWithDaysOfWeekMutation({ refetchQueries: refetchQueries });
  const [createGoalConfigurationWithIndividualDates] = useCreateGoalConfigurationWithIndividualDatesMutation({
    refetchQueries: refetchQueries,
  });
  const handleCreateGoalConfiguration = (input: CreateGoalConfigurationInputType) => {
    if ("dayOfWeekAssignments" in input) {
      createGoalConfigurationWithDaysOfWeek({ variables: { input } });
    } else {
      createGoalConfigurationWithIndividualDates({ variables: { input } });
    }
  };

  return (
    <RefetchQueriesContextProvider refetchQueries={refetchQueries}>
      <AthleteGoalTable
        paginationHooks={paginationHooks}
        rows={data?.goalConfigurationsForAthleteOffsetConnection.edges || []}
        loading={loading}
        totalRows={data?.goalConfigurationsForAthleteOffsetConnection.pageInfo.total || 0}
        tableHeader={
          <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
            <TWTabGroup
              tabs={[CURRENT_GOALS, PAST_GOALS]}
              onSelected={selected => {
                setGoalMode(selected);
              }}
            />
            <Button onClick={() => setCreateDialogOpen(true)}>Create Goal</Button>
          </Box>
        }
      />
      {createDialogOpen && (
        <GoalConfigurationCreateDialog
          athleteId={athleteId}
          open={createDialogOpen}
          onClose={() => setCreateDialogOpen(false)}
          onCreateGoalConfiguration={handleCreateGoalConfiguration}
        />
      )}
    </RefetchQueriesContextProvider>
  );
};
